import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './Toggle.module.sass';
import ClickableDiv from '../clickable_div/ClickableDiv';

const cx = classNames.bind(styles);

/** A simple toggle component with label. */
class Toggle extends Component {
  onChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event);
    }
  };

  render() {
    const {
      className,
      label,
      id,
      tabIndex,
      name,
      value,
      checked,
      disabled,
    } = this.props;
    const toggleCx = { disabled };

    return (
      <ClickableDiv
        className={cx(styles.toggleContainer, toggleCx, className)}
        onClick={this.onChange}
      >
        { label }
        <input
          className={styles.toggle}
          tabIndex={tabIndex}
          type="checkbox"
          id={id}
          name={name}
          value={value}
          onChange={this.onChange}
          disabled={disabled}
          checked={checked}
        />
        <span className={cx(styles.slider, styles.round)} />
      </ClickableDiv>
    );
  }
}

Toggle.propTypes = {
  /** Any CSS classes to apply to component. */
  className: PropTypes.string,
  /** Label for toggle. */
  label: PropTypes.string,
  /** Id for toggle. */
  id: PropTypes.string,
  /** Tab index for component's input tag. */
  tabIndex: PropTypes.number,
  /** Name for toggle. */
  name: PropTypes.string,
  /** Value for toggle. */
  value: PropTypes.string,
  /** Boolean indicating whether radio button should render as checked. */
  checked: PropTypes.bool,
  /** Boolean indicating whether radio button should render as disabled. */
  disabled: PropTypes.bool,
  /** onChange handler. */
  onChange: PropTypes.func,
};

Toggle.defaultProps = {
  className: null,
  label: null,
  id: null,
  tabIndex: -1,
  name: null,
  value: undefined,
  checked: undefined,
  disabled: false,
  onChange: null,
};

export default Toggle;
